import { createSelector } from "@reduxjs/toolkit";

import { LearnerOnboardingStateType } from "../../../utils";
import { StateType } from "../../../utils";

const selectOnboardingState = (state: StateType): LearnerOnboardingStateType =>
  state.learnerOnboardingReducer;

export const selectOnboardings = createSelector(
  selectOnboardingState,
  (state: LearnerOnboardingStateType) => state.onboardings
);

export const selectSingleOnboarding = createSelector(
  selectOnboardingState,
  (state: LearnerOnboardingStateType) => state.onboarding
);

export const selectOnboardingsLoading = createSelector(
  selectOnboardingState,
  (state: LearnerOnboardingStateType) => state.loading
);

export const selectOnboardingsLoaded = createSelector(
  selectOnboardingState,
  (state: LearnerOnboardingStateType) => state.loaded
);
